import { useMemo } from 'react'
import api from '../../lib/commons/api'
import {
  RoleRepository,
  RoleEntity,
  BatchUpdateRoleInput,
} from '../../applications/ports/roleRepository'

export const useRoleRepository = (): RoleRepository => {
  return useMemo(
    () => ({
      getList: async (): Promise<RoleEntity[]> => {
        const response = await api.functional.request('GET', '/api/v1/roles')
        return response.json as RoleEntity[]
      },
      batchUpdate: async (input: BatchUpdateRoleInput): Promise<void> => {
        await api.functional.request('POST', '/api/v1/roles/batch', input)
      },
    }),
    []
  )
}
